// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bscGreenfield as _bscGreenfield } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bscGreenfield chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1017
 * Chain Name: BNB Greenfield Chain
 * Default Block Explorer: https://greenfieldscan.com
 * Default RPC URL: https://greenfield-chain.bnbchain.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bscGreenfield } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bscGreenfield,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bscGreenfield = createCommon({
	..._bscGreenfield,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
